import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PLACEMENT_SCREENS } from 'shared/constants/common';
import { PlacementStateInterface, State } from 'shared/interface';
import { fetchPlacements } from 'shared/store/placement';
import { Mousewheel, SwiperOptions } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import BottomPlacementCard from '../card-views/BottomPlacementContent';
import './styles.scss';

interface Props {
	screen: PLACEMENT_SCREENS;
}

const Placement: React.FC<Props> = (props) => {
	const dispatch = useDispatch();
	const placementsData = useSelector<State, PlacementStateInterface>((state) => state.placements);
	// to filter out rare but possible situation where placements lenght is 0.
	const [isDataFetched, setDataFetched] = useState(false);

	useEffect(() => {
		if (!isDataFetched && !placementsData[props.screen]?.length) {
			dispatch(fetchPlacements(props.screen));
		}
		setDataFetched(true);
	}, [dispatch, props.screen, placementsData, isDataFetched]);

	const settings: SwiperOptions = {
		slidesPerView: 'auto',
		modules: [Mousewheel],
		allowTouchMove: true,
		grabCursor: true,
		threshold: 5,
		loop: true,
		spaceBetween: 8,
		preventClicks: true,
	};

	return (
		<>
			{placementsData[props.screen].length > 0 && (
				<section className="Placement" data-cy="placement">
					{!!placementsData?.[props.screen]?.length && (
						<Swiper {...settings} freeMode={true}>
							{placementsData[props.screen]?.map((placement) => (
								<SwiperSlide key={`placementsData-${placement.placementId}`}>
									<BottomPlacementCard dataBottomBanner={placement} fullWidth={placementsData[props.screen].length === 1} />
								</SwiperSlide>
							))}
						</Swiper>
					)}
				</section>
			)}
		</>
	);
};

export default Placement;
